import { render, staticRenderFns } from "./stopwordsComponent.vue?vue&type=template&id=58748202"
import script from "./stopwordsComponent.vue?vue&type=script&lang=js"
export * from "./stopwordsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports